module.exports = __webpack_public_path__ + "img/1.624d72c5.png";